import { helpers } from '~/components/hotels/details/themes/base'

export const HotelDetails = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({}),
})
